/** @format */

import { positionFindTreeDataByAll as findTreeDataByAll } from '@/api/position/index';
import { ActionUtils } from '@/utils/action';
import { TreeUtils } from '@/utils/tree';
import { $utils } from '@/utils/publicUtils';

export default {
	methods: {
		findTreeDataTypes(type, paramsOptions) {
			return new Promise((resolve, reject) => {
				switch (type) {
					case '1':
						this.findTreeDataByAll(paramsOptions)
							.then((res) => {
								resolve(res);
							})
							.catch(() => {
								reject([]);
							});
						break;
					case '2':
						this.findTreeDataByTheOrg(paramsOptions)
							.then((res) => {
								resolve(res);
							})
							.catch(() => {
								reject([]);
							});
						break;
					case '3':
						this.findTreeDataByOrg(paramsOptions)
							.then((res) => {
								resolve(res);
							})
							.catch(() => {
								reject([]);
							});
						break;
				}
			});
		},
		// 查询全部-1
		findTreeDataByAll(paramsOptions) {
			const params = {};
			if (paramsOptions.moreSearchParams) {
				Object.assign(params, paramsOptions.moreSearchParams);
			}
			// 范围选择器调用
			params.includeSub = true;
			params.posId = paramsOptions.node.level === 0 ? null : paramsOptions.node.data.id;
			return new Promise((resolve, reject) => {
				findTreeDataByAll(ActionUtils.formatParams(params))
					.then((res) => {
						const treeData = this.conformityData(paramsOptions, res, '1');
						resolve(treeData);
					})
					.catch(() => {
						reject([]);
					});
			});
		},
		// 查询当前-2
		// findTreeDataByTheOrg(paramsOptions) {
		// 	const params = {};
		// 	if (paramsOptions.moreSearchParams) {
		// 		Object.assign(params, paramsOptions.moreSearchParams);
		// 	}
		// 	params.includeSub = paramsOptions.hasSubset;
		// 	params.posId = paramsOptions.node.level === 0 ? null : paramsOptions.node.data.id;
		// 	return new Promise((resolve, reject) => {
		// 		findTreeDataByThePos(params)
		// 			.then((res) => {
		// 				const treeData = this.conformityData(paramsOptions, res.data, '2');
		// 				resolve(treeData);
		// 			})
		// 			.catch(() => {
		// 				reject([]);
		// 			});
		// 	});
		// },
		// 查询指定-3
		// findTreeDataByOrg(paramsOptions) {
		// 	const params = {};
		// 	if (paramsOptions.moreSearchParams) {
		// 		Object.assign(params, paramsOptions.moreSearchParams);
		// 	}
		// 	if (this.$utils.isEmpty(paramsOptions.node.data) || paramsOptions.node.data.id === '0') {
		// 		params.partyId = paramsOptions.partyId;
		// 	} else {
		// 		params.posId = paramsOptions.node.data.id;
		// 	}
		// 	params.includeSub = paramsOptions.hasSubset;

		// 	return new Promise((resolve, reject) => {
		// 		findTreeDataByPos(params)
		// 			.then((res) => {
		// 				const treeData = this.conformityData(paramsOptions, res.data, '3');
		// 				resolve(treeData);
		// 			})
		// 			.catch(() => {
		// 				reject([]);
		// 			});
		// 	});
		// },
		conformityData(paramsOptions, res, type) {
			let data = {};
			if ($utils.isEmpty(paramsOptions.node.data) || paramsOptions.node.data.id === '0') {
				if ($utils.isEmpty(paramsOptions.node.data)) {
					data = this.toTree(res);
				} else {
					const treeData = type === '1' ? res : this.filterTreeChildren(res, 'root');
					data = treeData;
				}
			} else if (paramsOptions.node.data.id !== '0') {
				if (type === '2') {
					const treeData = res.filter((a) => a.parentId === paramsOptions.node.data.id);
					data = this.toTree(treeData);
				} else if (type === '3') {
					const treeData =
						paramsOptions.node.data.id === '0'
							? this.filterTreeChildren(res, 'root')
							: res.filter((a) => a.parentId === paramsOptions.node.data.id);
					data = this.toTree(treeData);
				} else {
					data = this.toTree(res);
				}
			}
			return data;
		},
		toTree(data) {
			return TreeUtils.transformToTreeFormat(data, {
				idKey: 'id',
				pIdKey: 'parentId',
				childrenKey: 'children',
			});
		},
	},
};
